import { fadeIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../../assets/styles/colors";

const fadeInAnimation = keyframes`${fadeIn}`;

export const EmptyMessage = styled.div`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackTow
      : Color.textColorBlackTow};
`;

export const EmptyAddress = styled.div`
  animation: 1s ${fadeInAnimation};
`;

export const EmptyImg = styled.img``;
